import React from 'react';

import { TaskManagedAttributesNames } from '@bringg/common-utils';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { ManagedAttributesService } from '../../service/managed-attributes';
import AttributeListItem from '../attribute-list-item/attribute-list-item';

const TaskEscortDrivers = ({ taskId }: { taskId: number }) => {
	const { t } = useTranslation();
	const taskEscortDrivers = ManagedAttributesService.getManagedAttributeByName<string>(
		taskId,
		TaskManagedAttributesNames.TaskDrivers
	);

	if (!taskEscortDrivers) {
		return null;
	}

	return (
		<AttributeListItem
			name={t('MANAGED_ATTRIBUTES.TASK_ESCORT_DRIVERS.LABEL')}
			description={t('MANAGED_ATTRIBUTES.TASK_ESCORT_DRIVERS.DESCRIPTION')}
			displayValue={taskEscortDrivers}
		/>
	);
};

export default observer(TaskEscortDrivers);
